module.exports = __webpack_public_path__ + "static/img/top.ecc461b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amuletj/top.png
// module id = FmRJ
// module chunks = 2